import React from "react";
import {
  MinusOutlined,
  DownloadOutlined,
  PlusOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import Chart from "chart.js/auto";
import { Collapse, Select } from "antd";
import { Bar } from "react-chartjs-2";
import { ArcElement } from "chart.js";
import "./raktkoshDashboard.css";

Chart.register(ArcElement);
const { Option } = Select;
const { Panel } = Collapse;
function Defaulters() {
  const accordionKeys = ["1", "2", "3", "4", "5"];
  const barChartData = {
    labels: [
      "AB- ve",
      "AB+ ve",
      "A- ve",
      "A+ ve",
      "B- ve",
      "B+ ve",
      "Oh- ve",
      "Oh+ ve",
      "O- ve",
      "O+ ve",
    ],
    datasets: [
      {
        label: "Blood Availability Today",
        data: [2319, 4786, 4324, 1342, 5253, 9734, 8375, 2585, 9963, 2585],
        backgroundColor: "#50C0FF",
        borderWidth: 0,
      },
    ],
  };

  const numLabels = barChartData.labels.length;
  const maxChartHeight = 50 + numLabels * 30; // Adjust 50 and 30 as needed for padding and label height
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",
    scales: {
      x: {
        display: false, // Hide x-axis
        position: "none",
      },
      y: {
        ticks: {
          beginAtZero: true, // Y axis starts at 0
          stepSize: 50, // Adjust the step size as needed
          autoSkip: false,
        },
        display: true,
        position: "left",
      },
    },
    plugins: {
      legend: {
        display: false, // Hide legend
      },
    },
    maxHeight: maxChartHeight, // Set maximum height for chart before scrolling is enabled
    datasets: {
      bar: {
        barPercentage: 0.7, // Adjust the thickness of the bars
        categoryPercentage: 0.6, // Adjust the spacing between the bars
      },
    },
  };
    return (
        <div>
          <div className="col-12">
            <div>
              <p className="stats mb-2">Defaulters</p>
            </div>
            <div className="row mb-4 gy-4 def">

              <div className="col-6 defs">
                <div className="">
                  <Collapse
                    expandIconPosition="right"
                    expandIcon={({ isActive }) =>
                      isActive ? <MinusOutlined /> : <PlusOutlined />
                    }
                    defaultActiveKey={accordionKeys}
                    className="accodianHeader"
                  >
                    <Panel
                      header={
                        <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                          {" "}
                          Not Updating Stock{" "}
                          <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                        </span>
                      }
                      key="2"
                    >
                      <div>
                        <div style={{ height: "300px" }}>
                          <Bar data={barChartData} options={options} />
                        </div>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
              </div>
              <div className="col-6 defs">
                <div className="">
                  <Collapse
                    expandIconPosition="right"
                    expandIcon={({ isActive }) =>
                      isActive ? <MinusOutlined /> : <PlusOutlined />
                    }
                    defaultActiveKey={accordionKeys}
                    className="accodianHeader"
                  >
                    <Panel
                      header={
                        <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                          {" "}
                          Not Updating Monthly Report{" "}
                          <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                        </span>
                      }
                      key="2"
                    >
                      <div>
                        <div style={{ height: "300px" }}>
                          <Bar data={barChartData} options={options} />
                        </div>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
              </div>



            </div>
          </div>
        </div>
      );
}

export default Defaulters
